import React, { useState } from 'react';
import Select from 'react-select';
import { clearRedisKeyData } from '../../../services/api/clearRedisKey';

const containerStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

const inputButtonContainerStyle = {
  display: 'flex',
  alignItems: 'center',
};

const selectStyle = {
  width: '300px', // Adjust the width as needed
};

const buttonStyle = {
  backgroundColor: '#00baaa',
  color: '#fff',
  padding: '11px 10px',
  border: 'none',
  borderRadius: '5px',
  cursor: 'pointer',
};

const headingStyle = {
  textAlign: 'center',
  fontSize: '24px',
  margin: '0 0 20px 0',
};

function RedisMultiClearComponent() {
  const [selectedKeys, setSelectedKeys] = useState([]); 
  const [message, setMessage] = useState([]);
  // const [clearStatus, setClearStatus] = useState([])

  const handleClearKeys = async () => {
    let clearStatusResponse = []
    setMessage('');
    try {
      if (selectedKeys.length === 0) {
        alert('Please select one or more keys.');
      } else {
        for (const key of selectedKeys) {
          const response = await clearRedisKeyData(key.value);
          clearStatusResponse.push(response.data)
        }
        setMessage(clearStatusResponse)
        setSelectedKeys([]);
      }
    } catch (error) {
      setMessage(["An error occurred. Please try again!"]);
    }
  };

  const keyOptions = [
    'activeCountriesKey',
    'getCountriesKey',
    'getDocTypesKey',
    'menusKey',
    'getOrderTypesKey',
    'getStatesListKey',
    'getCompanyBusinessTypesKey',
    'getCompanyCreditPeriodsKey',
    'getCompanySizeCategoriesKey',
    'getCompanySupplyTypesKey',
    'getCompanyTypesKey',
    'getMaterialBrandsKey',
    'getMaterialCategoriesKey',
    'getMaterialIdTeamKey',
    'getAllMaterialUOMsKey',
    'getMaterialIdTypesKey',
    'getMaterialUOMsKey',
    'getPettyCashCategoriesKey',
    'getMaterialSpecificationMandatoryTypesKey',
    'ticketCategories',
    'ticketSubCategories'
  ].map((key) => ({ label: key, value: key }));

  return (
    <div className="container my-5" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <div style={containerStyle}>
        <div style={inputButtonContainerStyle}>
          <Select isMulti options={keyOptions} value={selectedKeys}
            onChange={(selectedOptions) => setSelectedKeys(selectedOptions)}
            styles={{ control: (provided) => ({ ...provided, ...selectStyle }) }}
          />
          <button className="mx-3" style={buttonStyle} onClick={handleClearKeys}>
            Clear Selected Keys
          </button>
        </div>
      </div>
      <div className="my-5">
        {Array.isArray(message)
          ? message.map((element, index) => (
            <div key={index}>{element}</div>  
          ))
          : <div>{message}</div>}
      </div>
    </div>
  );
}

export default RedisMultiClearComponent;
